import { useEffect } from 'react';

import {
  SPLITIO_KEY,
  useSplitIO,

  SALESFORCE_SALES_SCRIPT_SRC,
  SALESFORCE_SALES_DEPLOYMENT_NAME,
  REACT_APP_SF_SALES_CHAT_URL,

  SALESFORCE_LIVE_SCRIPT_SRC,
  SALESFORCE_LIVE_DEPLOYMENT_NAME,
  SALESFORCE_LIVE_CHAT_URL,

  SALESFORCE_CHAT_ORG_ID,
  SALESFORCE_CHAT_SCRT2_URL,
} from '@sky-tv-group/shared';

// Extend Window interface
declare global {
  interface Window {
    embeddedservice_bootstrap: any;
    sfChatReady?: boolean;
  }
}

interface SalesforceChatNewProps {
  chatType: 'sales' | 'live';
}

const SalesforceChatNew = ({ chatType }: SalesforceChatNewProps) => {
  // Read SplitIO flags
  let [salesChatEnabled] = useSplitIO(SPLITIO_KEY.SKY_WEB_SALESFORCE_NEW_CHAT_SALES);
  let [liveChatEnabled] = useSplitIO(SPLITIO_KEY.SKY_WEB_SALESFORCE_NEW_CHAT_LIVE);

  useEffect(() => {
    //  If script is already added → don't load again
    if (document.getElementById('sf-embedded-script')) return;

    //  Check SplitIO flags based on chatType
    if (chatType === 'sales' && !salesChatEnabled) {
      return;
    }

    if (chatType === 'live' && !liveChatEnabled) {
      return;
    }

    // Configuration mapping
    const config = {
      sales: {
        scriptSrc: SALESFORCE_SALES_SCRIPT_SRC,
        deploymentName: SALESFORCE_SALES_DEPLOYMENT_NAME,
        chatUrl: REACT_APP_SF_SALES_CHAT_URL,
      },
      live: {
        scriptSrc: SALESFORCE_LIVE_SCRIPT_SRC,
        deploymentName: SALESFORCE_LIVE_DEPLOYMENT_NAME,
        chatUrl: SALESFORCE_LIVE_CHAT_URL,
      },
    };

    const selectedConfig = config[chatType];

    // Inject script
    const script = document.createElement('script');
    script.id = 'sf-embedded-script';
    script.type = 'text/javascript';
    script.src = selectedConfig.scriptSrc;

    // script.onload = () => {
    //   try {
    //     window.embeddedservice_bootstrap.settings.language = 'en_US';

    //     window.embeddedservice_bootstrap.init(
    //       SALESFORCE_CHAT_ORG_ID,
    //       selectedConfig.deploymentName,
    //       selectedConfig.chatUrl,
    //       {
    //         scrt2URL: SALESFORCE_CHAT_SCRT2_URL,
    //       }
    //     );
    //   } catch (error) {
    //     console.error('Error loading Salesforce Embedded Messaging:', error);
    //   }
    // };
script.onload = () => {
  try {
    window.embeddedservice_bootstrap.settings.language = 'en_US';

    window.embeddedservice_bootstrap.init(
      SALESFORCE_CHAT_ORG_ID,
      selectedConfig.deploymentName,
      selectedConfig.chatUrl,
      {
        scrt2URL: SALESFORCE_CHAT_SCRT2_URL,
      }
    );

    // Poll until open() becomes available
    const interval = setInterval(() => {
      if (
        window.embeddedservice_bootstrap &&
        typeof window.embeddedservice_bootstrap.open === 'function'
      ) {
        window.sfChatReady = true;
        clearInterval(interval);
      }
    }, 300);
  } catch (error) {
    console.error('Error loading Salesforce Embedded Messaging:', error);
  }
};


    document.body.appendChild(script);

    return () => {
      const existingScript = document.getElementById('sf-embedded-script');
      if (existingScript) existingScript.remove();
    };
  }, [chatType, salesChatEnabled, liveChatEnabled]);

  return null;
};

export { SalesforceChatNew };
